import * as React from 'react';
import { CardBodyStyled, CardStyled } from './card.component.style';
export var Card = function (_a) {
    var children = _a.children, noPadding = _a.noPadding, outlined = _a.outlined;
    return (React.createElement(CardStyled, { outlined: outlined },
        React.createElement(CardBodyStyled, { noPadding: noPadding }, children)));
};
